import {selectorReducer, SelectorReducerActions, SelectorReducerState} from "./partial/selectorReducer";
import {SimulationReducerActions, SimulationReducerState, simulationReducer} from "./partial/simulationReducer";
import {historyReducer, HistoryReducerActions, HistoryReducerState} from "./partial/historyReducer";
import {levelReducer, LevelReducerActions, LevelReducerState} from "./partial/levelReducer";
import {UUID} from "../../data/model/UUID";
import toast from "react-hot-toast/headless";

export type EditorID = UUID;

export type EditorReducerState =
    {
        id: EditorID,
        updatedAt: number,
    }
    & SelectorReducerState
    & SimulationReducerState
    & HistoryReducerState
    & LevelReducerState

export type EditorReducerActions =
    | SelectorReducerActions
    | SimulationReducerActions
    | HistoryReducerActions
    | LevelReducerActions

const reducerOrder: ((state: EditorReducerState, action: EditorReducerActions) => EditorReducerState)[] = [
    selectorReducer,
    historyReducer,
    simulationReducer,
    levelReducer,
];

export function editorReducer(
    state: EditorReducerState,
    action: EditorReducerActions,
): EditorReducerState {
    let newState = state;

    try {
        reducerOrder.forEach(reducer  => {
            newState = {...newState, ...reducer(newState, action)};
        });
    } catch (error) {
        toast.error(error instanceof Error ? error.message : 'Unknown editor error.');
        console.error("Editor reducer error: ", error);
        return state;
    }

    return newState;
}